import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { DisplayAllowedDirective } from '../../services/directives/display-allowed.directive';
import { SessionTokenService } from './../../services/session-token.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, DisplayAllowedDirective],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject();
  unique_name = '';
  role = '';
  photo = '';

  shortName = '';

  permissionsRegistration: string[] = [
    'sapore.survey.user.all',
    'sapore.survey.branch.filter',
    'sapore.survey.permission.getall',
    'sapore.survey.customer.filter',
  ];

  constructor(
    private readonly router: Router,
    private readonly sessionTokenService: SessionTokenService,
    private readonly authService: AuthService
  ) {
    effect(() => this.redirectLogin(sessionTokenService.getToken()));
  }

  ngOnInit(): void {
    const userMe = this.sessionTokenService.getUserMe();
    
    if (userMe) {
      this.unique_name = userMe.name;
      this.role = userMe.roleName || '';
      this.photo = userMe.photo || '';
    }

    this.shortName = this.unique_name
      .split(' ')
      .map((name) => name[0])
      .join('')
      .substring(0, 2);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  redirectLogin(token: string | null): void {
    if (!token) this.router.navigate(['auth']);
  }

  logout(): void {
    const closeSession = () => {
      this.sessionTokenService.closeSession();
      this.router.navigate(['auth']);
    };

    if (this.sessionTokenService.getIsLoggedOffice365())
      this.authService
        .logoutOffice365()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          closeSession();
        });
    else closeSession();
  }
}
